import gql from 'graphql-tag';

export default gql`
  query cartGetAvailableDeliveryTimeSlots($supplierId: Int!, $start: String!, $end: String!, $storeId: String!) {
    cartGetAvailableDeliveryTimeSlots(supplierId: $supplierId, start: $start, end: $end, storeId: $storeId) {
      date
      timeSlots {
        start
        end
      }
    }
  }
`;
